import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import Typo from 'constants/typography'
import { REFERRAL_LOCIZE } from 'components/referral/landing/const'
import styles from './styles.scss'

const ReferralTermsAndConditions = ({ t }) => {
  const terms = hasLocizeTranslation(
    t,
    REFERRAL_LOCIZE.REFERRAL_TNC_TEXT.key,
    REFERRAL_LOCIZE.REFERRAL_TNC_TEXT.text,
  )

  const termsList = terms.split('\n')
  return (
    <React.Fragment>
      <style jsx>{styles}</style>
      <div className="referral-landing-tnc">
        <div className="referral-landing-tnc__wrapper">
          <span className={clsx('referral-landing-tnc__title', Typo.subtitle2)}>
            {hasLocizeTranslation(
              t,
              REFERRAL_LOCIZE.REFERRAL_TNC_TITLE.key,
              REFERRAL_LOCIZE.REFERRAL_TNC_TITLE.text,
            )}
          </span>
          <ul className="referral-landing-tnc__list">
            {termsList.map((item, index) => (
              <li key={index}>
                <span className={Typo.body2}>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </React.Fragment>
  )
}

ReferralTermsAndConditions.propTypes = {
  t: PropTypes.func.isRequired,
}

export default withI18next()(ReferralTermsAndConditions)
